import React from 'react';
import { Placeholder } from '@sitecore-jss/sitecore-jss-react';

const FormPageInner = ({ rendering, params, setCallback }) => {
  let containerClass = 'vds-page-container__inner';
  if (params?.innerVariant === 'FormPage') {
    containerClass = 'vds-d2c-form-page__inner';
  }
  return (
    <div
      className={`vds-page-container__section${
        params?.bgColor ? ` vds-page-container__section--${params?.bgColor}-bg` : ''
      }`}
    >
      <div className={containerClass}>
        <Placeholder name="section-content" rendering={rendering} setCallback={setCallback} />
      </div>
    </div>
  );
};

export default FormPageInner;
